import React, { FC } from 'react';
import { contactDetailsInitialValues } from 'components/ContactDetails/utils';
import { donorContactDetails } from './contactDetails';
import { SurrogateContactDetails } from './SurrogateContactDetails';
import {
  ContactValues,
  SurrogateContactDetailsConnectedProps,
} from './SurrogateContactDetails.interface';
import { surrogateValidationSchema } from './validation';

export const SurrogateContactDetailsConnected: FC<
  SurrogateContactDetailsConnectedProps
> = ({ submit, profileData, states }) => {
  const onSubmit = async (data: ContactValues) => {
    const postData = { ...data };

    // NOTE: We omit sending location in the payload on submit - agreed as part of the api contract
    // NOTE: We silence TS error due to a bug in api schema - location should be optional
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete postData?.address?.location;

    // Handle same mailing address logic
    if (postData.same_mailing_address && postData.address) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      postData.mailing_address = postData.address;
    }

    // Remove mailing address fields if same_mailing_address is true
    if (postData.same_mailing_address) {
      delete postData.mailing_address;
    }

    // Remove same_mailing_address field as it's not part of the API
    delete postData.same_mailing_address;

    // Add has_mailing_address flag to the payload
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    postData.has_mailing_address = !data.same_mailing_address;

    await submit(postData);
  };

  const initialValues = contactDetailsInitialValues(
    donorContactDetails,
    profileData,
    // TODO: Remove if some profile types will be fixed (set as optional).
    // Reported as an issue : https://linear.app/nodal-health/issue/NOD-266/backend-bug-in-api-schema-for-parents-and-donor-profile
  ) as ContactValues;

  return (
    <SurrogateContactDetails
      initialValues={{
        ...initialValues,
        same_mailing_address: true,
      }}
      onSubmit={onSubmit}
      validationSchema={surrogateValidationSchema}
      states={states}
    />
  );
};
